var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { socket, syncSocketAuthToken } from "api";
import { userDataStore } from "store";
var BALANCE_UPDATE_EVENT = "balance:update";
var useRealtimeBalanceUpdate = function () {
    var queryClient = useQueryClient();
    var userId = userDataStore(function (state) { var _a; return (_a = state.user) === null || _a === void 0 ? void 0 : _a.id; });
    useEffect(function () {
        var handleBalanceUpdate = function (payload) {
            queryClient.setQueryData(["profile"], function (oldData) {
                var _a;
                if (!oldData)
                    return oldData;
                // 1. Обработка исключения для WBNB
                var displaySymbol = payload.symbol === "WBNB" ? "BNB" : payload.symbol;
                var displayName = payload.symbol === "WBNB" ? "Binance Coin" : payload.symbol;
                var coinExists = (_a = oldData.coinBalances) === null || _a === void 0 ? void 0 : _a.some(function (coin) { return coin.coinId === payload.coinId; });
                var newBalances;
                if (coinExists) {
                    newBalances = oldData.coinBalances.map(function (coin) {
                        return coin.coinId === payload.coinId
                            ? __assign(__assign({}, coin), { symbol: displaySymbol, balance: payload.balance, totalUsd: payload.totalUsd }) : coin;
                    });
                }
                else {
                    var newCoin = {
                        coinId: payload.coinId,
                        symbol: displaySymbol,
                        name: displayName,
                        balance: payload.balance,
                        totalUsd: payload.totalUsd,
                    };
                    newBalances = __spreadArray([newCoin], oldData.coinBalances, true);
                }
                newBalances.sort(function (a, b) { return parseFloat(b.totalUsd) - parseFloat(a.totalUsd); });
                return __assign(__assign({}, oldData), { coinBalances: newBalances });
            });
        };
        socket.on(BALANCE_UPDATE_EVENT, handleBalanceUpdate);
        return function () {
            socket.off(BALANCE_UPDATE_EVENT, handleBalanceUpdate);
        };
    }, [queryClient]);
    useEffect(function () {
        syncSocketAuthToken();
        if (!userId)
            return;
        if (!socket.connected) {
            socket.connect();
        }
    }, [userId]);
};
export default useRealtimeBalanceUpdate;
